export default __webpack_public_path__ + "static/media/E404.b36ca85a.png";